import React, { useMemo } from 'react';
import { createEssentials } from '@wix/fe-essentials-standalone';
import { Trans, useTranslation } from '@wix/wix-i18n-config';
import { PremiumPurchasePlatformModule } from '@wix/premium-purchase-platform/@sdk';
import { PremiumEssentialsProvider } from '@wix/premium-fed-sdk/@premium-essentials';
import { getContext } from './utils';
import { CheckoutPage } from './CheckoutPage';
import '@wix/design-system/styles-default.global.css';
export function Checkout(_ref) {
  let {
    artifactId,
    productTypeId,
    ...props
  } = _ref;
  const {
    i18n
  } = useTranslation();
  const useStandaloneEssentials = () => useMemo(() => createEssentials({
    environment: {
      language: 'en',
      artifactId,
      version: '1.0.0'
    }
  }), []);
  const {
    httpClient,
    biLogger
  } = useStandaloneEssentials();
  const context = useMemo(() => getContext(productTypeId), [productTypeId]);
  return /*#__PURE__*/React.createElement(PremiumEssentialsProvider, {
    httpClient: httpClient,
    i18n: i18n,
    Trans: Trans,
    biLogger: biLogger
  }, /*#__PURE__*/React.createElement(PremiumPurchasePlatformModule.Provider, {
    translations: {
      Loading: /*#__PURE__*/React.createElement(React.Fragment, null)
    },
    context: context
  }, /*#__PURE__*/React.createElement(CheckoutPage, props)));
}
//# sourceMappingURL=Checkout.js.map